import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import styled from 'styled-components';
import { Typography, Card, CardActions, CardContent } from '@material-ui/core';

import authService from 'services/auth.service';
import { setIsAuthed } from 'state/app.state';
import { Colors, SystemErrors } from 'typings';

const LoginWrapper = styled('div')`
  background-color: ${(props) => props.theme.palette.primary.main};
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
`;

const LoginCard = styled(Card)`
  margin: 0 auto;
  padding: ${(props) => props.theme.spacing(15)};
  background-color: ${Colors.WHITE};
  color: ${Colors.BLACK};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Login = () => {
  const dispatch = useDispatch();
  const [loginFailureMessage, setLoginFailureMessage] = useState('');

  const handleLogin = async (response: CredentialResponse) => {
    const googleUserToken = response?.credential || '';
    try {
      await authService.login(googleUserToken);

      if (authService.isAuthed()) {
        dispatch(setIsAuthed(true));
      }
    } catch (error: any) {
      console.error('Login Error:', { error });

      let message;
      if (!error.error?.statusCode || error.error.statusCode >= 500) {
        // timeout or server error
        message = SystemErrors.LOGIN;
      }

      if (!message) {
        message = error.error?.data?.message ?? 'Login Failed';
      }

      setLoginFailureMessage(message);
    }
  };

  return (
    <LoginWrapper>
      <LoginCard raised>
        <CardContent>
          <Typography variant="h5">Hello!</Typography>
          <Typography variant="subtitle2">Sign in below</Typography>
          {loginFailureMessage && (
            <Typography variant="caption" color="error">
              {loginFailureMessage}
            </Typography>
          )}
        </CardContent>
        <CardActions>
          <GoogleLogin
            onSuccess={handleLogin}
            onError={() => {
              console.log('Login Failed');
            }}
          />
        </CardActions>
      </LoginCard>
    </LoginWrapper>
  );
};

export default Login;
